import { env } from "../env";

const getBackend = (type = "local") => {
    return type === "session" ? window.sessionStorage : window.localStorage;
};

export const createStorage = (type = "local") => {
    const backend = getBackend(type);

    const safe = (fn, fallback) => {
        try {
            return fn();
        } catch (_) {
            return fallback;
        }
    };

    return {
        set(key, value) {
            return safe(() => backend.setItem(key, JSON.stringify(value)), undefined);
        },
        get(key, defaultValue = null) {
            return safe(() => {
                const raw = backend.getItem(key);
                return raw == null ? defaultValue : JSON.parse(raw);
            }, defaultValue);
        },
        remove(key) {
            return safe(() => backend.removeItem(key), undefined);
        },
        clear() {
            return safe(() => backend.clear(), undefined);
        }
    };
};

// Defaults for convenience
export const localStore = createStorage("local");
export const sessionStore = createStorage("session");

export const isProvider = (env.REACT_APP_IS_PROVIDER || "").toLowerCase() === "true";

// Default storage based on provider flag
export const storage = isProvider ? sessionStore : localStore;
export const STORAGE_KEYS = {
    accessToken: "accessToken",
    user: "user",
    balance: "balance",
    autoPrint: "autoPrint",
    isLoggedIn: "isLoggedIn",
    localVersion: "localVersion",
    configAll: "allConfig-v6",
    lotto5Betting: "betting_lotto5",
    lotto6Betting: "betting_lotto6",
    lotto12Betting: "betting_lotto12",
    lotto12v2Betting: "betting_lotto12v2",
};
